import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SOLUTIONS } from "../data/content";

export default function SolutionsTeaser() {
  return (
    <section
      data-testid="solutions-teaser"
      className="relative py-24 md:py-32 px-6 md:px-10 border-t border-white/5 bg-slate-950"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="text-[11px] tracking-[0.3em] uppercase text-cyan-400 font-mono mb-4">
              / 02 — Solutions
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-slate-50">
              End-to-end systems,
              <br />
              <span className="text-slate-500">expertly integrated.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-base md:text-lg text-slate-400 leading-relaxed">
              Six core capabilities — engineered, deployed and maintained as a single
              security ecosystem. Click any to explore the full specification.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {SOLUTIONS.map((s, idx) => {
            const Icon = s.icon;
            return (
              <Link
                to={`/solutions#${s.id}`}
                key={s.id}
                data-testid={`solution-teaser-${s.id}`}
                className="bg-slate-950 p-7 md:p-8 hover:bg-slate-900 transition-colors duration-500 group block"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="h-11 w-11 border border-cyan-400/30 bg-cyan-400/5 flex items-center justify-center group-hover:border-cyan-400 group-hover:bg-cyan-400/10 transition-colors">
                    <Icon className="h-5 w-5 text-cyan-300" strokeWidth={1.6} />
                  </div>
                  <span className="text-[11px] tracking-[0.3em] uppercase text-slate-600 font-mono">
                    0{idx + 1}
                  </span>
                </div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 font-mono mb-2">
                  {s.subtitle}
                </div>
                <h3 className="text-xl font-medium text-slate-50 tracking-tight mb-3">
                  {s.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed mb-5">
                  {s.short}
                </p>
                <span className="inline-flex items-center gap-2 text-xs text-cyan-300 uppercase tracking-[0.2em] font-mono group-hover:gap-3 transition-all">
                  Learn more
                  <ArrowUpRight className="h-3.5 w-3.5" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
